import { atom } from 'jotai';

export type TErrorContext =
  | 'default'
  | 'unauthenticated'
  | 'unauthorized'
  | 'bad_request'
  | 'payment';

export type TAppError = {
  error: Error;
  context?: TErrorContext;
};

const errorAtom = atom<TAppError[]>([]);

export { errorAtom };
